//departmentActions.js
import axios from 'axios'
import { CONST_API } from '../../../constants/api'
import { REDUX_CONST } from '../../constants'
import { logout } from '../userActions'
import { CONST_ERRORS } from '../../../constants/general'
export const resetDepartmentItem = (key) => async (dispatch) => {
	switch (key) {
		case 'createDepartment':
			dispatch({ type: REDUX_CONST.departmentConstants.createDepartment.reset })

			break
		case 'updateDepartment':
			dispatch({ type: REDUX_CONST.departmentConstants.updateDepartment.reset })

			break
		case 'deleteDepartment':
			dispatch({ type: REDUX_CONST.departmentConstants.deleteDepartment.reset })

			break
		default:
			break
	}
}

export const getDepartments = () => async (dispatch, getState) => {
	// console.log('Events:Request:GetEvents')
	try {
		dispatch({
			type: REDUX_CONST.departmentConstants.getDepartments.request,
		})

		const {
			userLogin: { userInfo },
		} = getState()

		const config = {
			headers: {
				Authorization: `Bearer ${userInfo.token}`,
			},
		}

		const { data } = await axios.get(
			CONST_API.channels.departments + CONST_API.routes.home,
			config,
		)

		dispatch({
			type: REDUX_CONST.departmentConstants.getDepartments.success,
			payload: data,
		})
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message
		if (message === CONST_ERRORS['401ExpiredToken']) {
			dispatch(logout())
		}
		dispatch({
			type: REDUX_CONST.departmentConstants.getDepartments.fail,
			payload: message,
		})
	}
}
export const createDepartment = (department) => async (dispatch, getState) => {
	const { department: departmentName, group, order } = department
	try {
		dispatch({
			type: REDUX_CONST.departmentConstants.createDepartment.request,
		})

		const {
			userLogin: { userInfo },
		} = getState()

		const config = {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${userInfo.token}`,
			},
		}

		const { data } = await axios.post(
			CONST_API.channels.departments + CONST_API.routes.home,
			{ department: departmentName, group, order },
			config,
		)

		dispatch({
			type: REDUX_CONST.departmentConstants.createDepartment.success,
			payload: data,
		})

		// localStorage.setItem(CONST_LOCAL_STORAGE.userInfo, JSON.stringify(data))
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message
		if (message === CONST_ERRORS['401ExpiredToken']) {
			dispatch(logout())
		}
		dispatch({
			type: REDUX_CONST.departmentConstants.createDepartment.fail,
			payload: message,
		})
	}
}

export const deleteDepartment = (id) => async (dispatch, getState) => {
	// console.log(id)
	try {
		dispatch({
			type: REDUX_CONST.departmentConstants.deleteDepartment.request,
		})

		const {
			userLogin: { userInfo },
		} = getState()

		const config = {
			headers: {
				Authorization: `Bearer ${userInfo.token}`,
			},
		}

		const { data } = await axios.delete(
			`${CONST_API.channels.departments + CONST_API.routes.home + id}`,
			config,
		)

		dispatch({
			type: REDUX_CONST.departmentConstants.deleteDepartment.success,
			payload: data,
		})
	} catch (error) {
		console.log('error')
		console.log(error)
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message
		if (message === CONST_ERRORS['401ExpiredToken']) {
			dispatch(logout())
		}
		dispatch({
			type: REDUX_CONST.departmentConstants.deleteDepartment.fail,
			payload: message,
		})
	}
}

export const updateDepartment = (department) => async (dispatch, getState) => {
	try {
		dispatch({
			type: REDUX_CONST.departmentConstants.updateDepartment.request,
		})

		const {
			userLogin: { userInfo },
		} = getState()
		const config = {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${userInfo.token}`,
			},
		}

		const { data } = await axios.put(
			`${
				CONST_API.channels.departments + CONST_API.routes.home + department._id
			}`,
			department,
			config,
		)

		dispatch({
			type: REDUX_CONST.departmentConstants.updateDepartment.success,
			payload: data,
		})
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message
		if (message === CONST_ERRORS['401ExpiredToken']) {
			dispatch(logout())
		}
		dispatch({
			type: REDUX_CONST.departmentConstants.updateDepartment.fail,
			payload: message,
		})
	}
}
